import { render } from "./MScAddModal.vue?vue&type=template&id=09e4908e&scoped=true&ts=true"
import script from "./MScAddModal.vue?vue&type=script&lang=ts"
export * from "./MScAddModal.vue?vue&type=script&lang=ts"

import "./MScAddModal.vue?vue&type=style&index=0&id=09e4908e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e4908e"]])

export default __exports__